var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isNative)?_c('div',{staticClass:"order-page",on:{"click":_vm.goOrder}},[_c('span',[_vm._v("订单")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }